import useAuth from 'hooks/useAuth';
import { useMutation, useQuery } from 'react-query';

export default function useCustomForm({ formId }) {
  const { request, userId } = useAuth();
  const {
    data: customForm,
    refetch,
    isLoading
  } = useQuery(`/custom-forms/${formId}`, () => request.get(`/custom-forms/${formId}`).then((response) => response.data as CustomForm), {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });

  const { mutateAsync: updateCustomForm, isLoading: updatingCustomForm } = useMutation(
    `/custom-forms${formId}`,
    (payload: any) => request.put(`/custom-forms/${formId}`, payload).then((response) => response.data),
    {
      onSuccess: () => refetch()
    }
  );

  return { customForm, refetch, isLoading, updateCustomForm, updatingCustomForm };
}

interface CustomForm {
  _id: string;
  user: string;
  title: string;
  titleFrench: string;
  description: string;
  descriptionFrench: string;
  languageEnglish: boolean;
  languageFrench: boolean;
  json?: any[];
  isDraft?: boolean;
  createdAt?: string;
  updatedAt?: string;
}
